import { Component, Input, OnInit, Injector, EventEmitter, Output } from '@angular/core';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";


const COL_COUNT = 4;

@Component({
    selector: 'bt-row-4',
    imports: [LibModulesWolcModule],
    templateUrl: './bt-row-4.component.html',
    styleUrl: './bt-row-4.component.scss'
})
export class BtRow4Component {

  @Input() grid: any = { };
  @Input() grids: any[] = [];
  @Input() opts: any = { };

  @Input() g: any[] = [];

  constructor() {

  }

  ngOnInit(): void {
    if (this.grids?.length) this.g = [...this.grids];
    if (this.g == undefined) this.g = [ ];

    if (this.g.length < COL_COUNT) {
      for (let i = this.g.length; i < COL_COUNT; i++) {
        this.g.push(this.grid || { })
      }
    }
    // MiscUtil.extend(this.g, this.grid);

  }

}


